import { useEffect,useState } from "react";
import { useProductsWithQuery } from "store/utils/hooks";

export const useHasPromotions = () => {
  const [hasPromotions, setHasPromotions] = useState<boolean | null>(null);
  
  // Usamos el mismo parámetro que en PagePromotions
  const [products, isLoading] = useProductsWithQuery({ in_promotion: 1 }, true);

  useEffect(() => {
    if (!isLoading) {
      // Verificamos si products es un array y tiene elementos
      const hasProducts = Array.isArray(products) && products.length > 0;
      setHasPromotions(hasProducts);
    }
  }, [products, isLoading]);

  return { hasPromotions, isLoading };
};
